import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import { buildExtractedSpecRows, formatFieldDisplayValue } from '../../utils/productEnrichment';

/**
 * Collapsed read-only panel for AI-extracted specs (field_diffs + raw_extracted_json).
 */
const ProductEnrichmentExtractedSpecsPanel = ({ detail }) => {
  const rows = buildExtractedSpecRows(detail);

  if (!rows.length) {
    return null;
  }

  return (
    <Accordion className="mt-4">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Extracted specs</Accordion.Header>
        <Accordion.Body className="p-0">
          <Table bordered responsive size="sm" className="mb-0">
            <thead>
              <tr>
                <th>Field</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(row => (
                <tr
                  key={row.key}
                  className={row.highlight ? 'table-warning' : undefined}
                >
                  <td>
                    {row.label}
                    {row.highlight && (
                      <Badge bg="warning" text="dark" className="ms-2">
                        catalog mismatch
                      </Badge>
                    )}
                  </td>
                  <td>{formatFieldDisplayValue(row.value)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default ProductEnrichmentExtractedSpecsPanel;
